import { Link } from "react-router-dom";
import type { SiteWithCategory } from "@/types/nav";
import { formatVisits } from "@/lib/navData";
import { getTone } from "@/lib/tone";

export default function HotRanking({ sites }: { sites: SiteWithCategory[] }) {
  return (
    <div className="rounded-xl border border-background-200 bg-background-50 overflow-hidden">
      <ul>
        {sites.map((site, index) => {
          const tone = getTone(site.tone);
          const isTop = index < 3;
          return (
            <li key={site.id} className="border-b border-background-100 last:border-0">
              <Link
                to={`/detail/${site.id}`}
                className="flex items-center gap-3 px-4 py-3 hover:bg-background-100/70 transition-colors cursor-pointer"
              >
                <span
                  className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-heading font-bold shrink-0 ${
                    isTop ? "bg-accent-100 text-accent-700" : "bg-background-100 text-foreground-500"
                  }`}
                >
                  {index + 1}
                </span>
                <span
                  className={`w-8 h-8 rounded-lg bg-gradient-to-br ${tone.gradient} text-background-50 flex items-center justify-center text-xs font-bold shrink-0`}
                >
                  {site.logoText}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm font-medium text-foreground-900 truncate">{site.name}</span>
                  <span className="block text-xs text-foreground-400 truncate">{site.categoryName}</span>
                </span>
                <span className="text-xs text-foreground-400 flex items-center gap-1 shrink-0">
                  <i className="ri-fire-line text-accent-500" />
                  {formatVisits(site.visits)}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}